import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  fonts: {
    heading: "'Max', sans-serif",
    body: "'Noto Sans', sans-serif",
  },
  colors: {
    ahuaBlue: {
      0: "#E6F2FA",
      5: "#D2E9F9",
      10: "#BCDFF8",
      20: "#82C5F4",
      30: "#55AEED",
      40: "#2F95E5",
      50: "#137ED9",
      60: "#0068CA",
      70: "#0058B7",
      80: "#0047A0",
      90: "#003686",
      100: "#00276B",
    },
  },
})

export default theme
